export class GeneralConfig {
  public readonly ServerHost = import.meta.env.VITE_API_URL as string
}
